import { ENV } from '../../config/runtimeEnv';
import { UnavailableBlock, UnavailableBlockPayload } from "../../types/admin/TeamTypes";
import type { UserUuid } from "../../types/identity";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_HEALTHCARE_SERVER;

const getAuthHeaders = () => ({
	"Content-Type": "application/json",
});

export interface UnavailableBlockWriteResponse {
	message: string;
	data: UnavailableBlock;
	// Always [] — auth cannot see appointments, so the caller asks healthcare separately.
	conflicting_appointments: unknown[];
}

export const createUnavailableBlock = async (userId: UserUuid, payload: UnavailableBlockPayload): Promise<UnavailableBlockWriteResponse> => {
	const response = await http.post(`${API_BASE_URL}/practitioner/${userId}/unavailable-blocks`, payload, {
		headers: getAuthHeaders(),
	});

	return response.data;
};

// A full replacement of the range, and user_id is not updatable — move a block by delete + create.
export const updateUnavailableBlock = async (userId: UserUuid, blockId: number, payload: UnavailableBlockPayload): Promise<UnavailableBlockWriteResponse> => {
	const response = await http.put(`${API_BASE_URL}/practitioner/${userId}/unavailable-blocks/${blockId}`, payload, {
		headers: getAuthHeaders(),
	});

	return response.data;
};

export const deleteUnavailableBlock = async (userId: UserUuid, blockId: number): Promise<{ message: string }> => {
	const response = await http.delete(`${API_BASE_URL}/practitioner/${userId}/unavailable-blocks/${blockId}`, {
		headers: getAuthHeaders(),
	});

	return response.data;
};

export const createClinicClosure = async (payload: UnavailableBlockPayload): Promise<UnavailableBlockWriteResponse> => {
	const response = await http.post(`${API_BASE_URL}/practitioner/clinic-closures`, payload, {
		headers: getAuthHeaders(),
	});

	return response.data;
};

export const updateClinicClosure = async (blockId: number, payload: UnavailableBlockPayload): Promise<UnavailableBlockWriteResponse> => {
	const response = await http.put(`${API_BASE_URL}/practitioner/clinic-closures/${blockId}`, payload, {
		headers: getAuthHeaders(),
	});

	return response.data;
};

export const deleteClinicClosure = async (blockId: number): Promise<{ message: string }> => {
	const response = await http.delete(`${API_BASE_URL}/practitioner/clinic-closures/${blockId}`, {
		headers: getAuthHeaders(),
	});

	return response.data;
};
